import { FormEvent, useState } from 'react';

import { ToggleSwitch } from '../../shared/ToggleSwitch/ToggleSwitch';
import { SpeechBubble } from '../../shared';

import { useSkuStatuses } from '../../hooks/skuStatus';

import { ApiAvailableStore } from '../../types/enums/store.enum';

const DESCRIPTION_BY_STORE: Record<ApiAvailableStore, string> = {
    [ApiAvailableStore.APPLE]:
        'Check which of our SKUs are actually published in the App Store.',
    [ApiAvailableStore.GOOGLE]:
        'Check which of our SKUs are actually published in Google Play.',
};

export const SkuStatusForm = ({ store }: { store: ApiAvailableStore }) => {
    const [isOnlyActive, setIsOnlyActive] = useState<boolean>(true);

    const { checkSkuStatuses, skuStatuses, isChecking, errorMessage } =
        useSkuStatuses(store);

    const onSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        checkSkuStatuses(isOnlyActive);
    };

    return (
        <>
            <SpeechBubble
                style={{
                    justifyContent: 'left',
                    marginTop: 10,
                    marginBottom: 20,
                }}
            >
                {DESCRIPTION_BY_STORE[store]}
            </SpeechBubble>
            <form onSubmit={onSubmit}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        marginBottom: 12,
                    }}
                >
                    <ToggleSwitch
                        checked={isOnlyActive}
                        onToggle={() =>
                            setIsOnlyActive((currentValue) => !currentValue)
                        }
                        disabled={isChecking}
                    />
                    <span>
                        {isOnlyActive
                            ? 'Check only active SKUs'
                            : 'Check all SKUs'}
                    </span>
                </div>

                <button type="submit" className="btn" disabled={isChecking}>
                    {isChecking ? 'Checking...' : 'Check SKU statuses'}
                </button>
            </form>
            {errorMessage ? (
                <pre style={{ color: 'red' }}>{errorMessage}</pre>
            ) : null}
            {skuStatuses ? (
                <pre>Checked {skuStatuses.skus.length} SKUs.</pre>
            ) : null}
        </>
    );
};
